// extracted by mini-css-extract-plugin
module.exports = {"DrawingCheckIcon":"dropdown_DrawingCheckIcon__HTv1W","DropdownIcon":"dropdown_DropdownIcon__gdvdm"};